import type { ReactNode } from "react";
import { usePageTitle } from "../pages/usePageTitle";

/**
 * The frame for /terms and /privacy. The text inside is WealthyPlanet's existing legal copy,
 * converted from the Google Docs verbatim; only the formatting (headings, lists, links) is new.
 * Neither doc carries a "last updated" date, so none is shown. Don't edit the wording here: legal
 * changes come from the documents.
 */
export function LegalPage({
  slug,
  title,
  children,
}: {
  slug: string;
  title: string;
  children: ReactNode;
}) {
  usePageTitle(title);
  return (
    <div className="spage on" data-s={slug}>
      <header className="hero" style={{ paddingBottom: 0 }}>
        <div className="wrap">
          <h1>{title}</h1>
        </div>
      </header>
      <section className="band">
        <div className="wrap">
          <article className="sprose">{children}</article>
        </div>
      </section>
    </div>
  );
}

export const LEGAL_EMAIL = "info@wealthyplanet.com";

export function MailLink() {
  return <a href={`mailto:${LEGAL_EMAIL}`}>{LEGAL_EMAIL}</a>;
}
